<template>
  <span
    :class="{ 'page-link': true, selected: selected }"
    @click="$emit('click')"
  >
    <slot></slot>
  </span>
</template>
<script>
export default {
  props: ["selected"],
  emits: ["click"],
};
</script>
